// extracted by mini-css-extract-plugin
module.exports = {"form":"SearchBar-module--form--B7IS8"};